import React from 'react';
import './LogoBar.css';
// ÜRÜN KURALI: kalp YOK → bildirim ikonu çan (bell).
import { AiOutlineBell } from 'react-icons/ai';
import { IoLocationOutline } from 'react-icons/io5';
import myliveIcon from './mylive-icon.png';
import { useHiddenUids } from './hooks/useHiddenUids';
import { useUnreadNotificationCount } from './services/notifications';
import { IkonKoprusu } from "./icon-system/runtime/IkonKoprusu";

// 📏 ÇAĞRI YERİ SAYIMI: `<LogoBar` → 1 çağrı (App.tsx:992). Üçü de argümansız
// `() => handleNavChange(...)` geçiyor; gövde doğrudan `onClick`e veriyor.
type LogoBarProps = {
  onNotificationClick?: () => void;
  onLiveClick?: () => void;
  onLocationClick?: () => void;
};

function LogoBar({ onNotificationClick, onLiveClick, onLocationClick }: LogoBarProps) {
    // Faz 1F Görev 1+4 — bildirim rozeti engellenen + sessize alınan kullanıcıdan gelenleri saymaz.
    // TEK KAYNAK: useUnreadNotificationCount (services/notifications) — DM
    // bildirimlerini eler + hiddenSet aktörlerini düşer. LogoBar, Bildirimler
    // ve V3 paneli artık AYNI semantikten geçer (rozet sürüklenmesi yok).
    const { hiddenSet } = useHiddenUids();
    const unreadCount = useUnreadNotificationCount(hiddenSet);
    const badgeText = unreadCount > 99 ? "99+" : unreadCount > 0 ? String(unreadCount) : "";

    return (
        <header className="logobar-container">
            <div className="logobar-logo-container" onClick={() => window.location.reload()}>
                <span className="logobar-wordmark">mylasa</span>
            </div>
            
            <div className="logobar-icons-container">
                <div className="logobar-icon-wrapper">
                    <button className="logobar-icon-btn pressable" data-eye-compact="true" onClick={onNotificationClick} title="Bildirimler">
                        <IkonKoprusu aile="notification.bell" className="logobar-icon" eski={<AiOutlineBell className="logobar-icon" />} />
                    </button>
                    {badgeText && (
                        <span
                            className="notification-badge"
                            aria-label={`${unreadCount} okunmamış bildirim`}
                        >
                            {badgeText}
                        </span>
                    )}
                </div>
                <button className="logobar-icon-btn pressable" data-eye-compact="true" onClick={onLocationClick} title="Konumlar">
                    <IkonKoprusu aile="navigation.map" className="logobar-icon" eski={<IoLocationOutline className="logobar-icon" />} />
                </button>
                <button className="logobar-icon-btn pressable" data-eye-compact="true" onClick={onLiveClick} title="Canlı Yayın">
                    <img src={myliveIcon} alt="Canlı Yayın" style={{ width: 36, height: 36, display: 'block', objectFit: 'contain' }} />
                </button>
            </div>
        </header>
    );
}

export default LogoBar;
